export default __webpack_public_path__ + "static/share-e64a5ce3af21adc95e84ee286c2725e1.jpg";